/* eslint-disable max-statements */

import React from "react";
import Kbbimage from "./component";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { makePriceLabelRound } from "../../../utils/helpers/make-price-label";
import { NUMBER } from "../../../constants/app-constants";

const KbbWrapper = ({kbbAskingPriceRangeMin, kbbAskingPriceRangeMax, carEgcPrice = 0}) =>  {

    let position = "left";
    let dynamicStyle = "styles.left";
    let centerGreen = "";

    const midKbbValue = (kbbAskingPriceRangeMin + kbbAskingPriceRangeMax) / NUMBER.TWO;
    if (carEgcPrice === midKbbValue) {
        position = "center";
        dynamicStyle = "styles.centers";
        centerGreen = "centeredGreen";
    } else if (carEgcPrice > kbbAskingPriceRangeMin && carEgcPrice < midKbbValue) {
        position = "leftGreen";
        dynamicStyle = "styles.left";
    } else if (carEgcPrice < kbbAskingPriceRangeMax && carEgcPrice > midKbbValue) {
        position = "rightGreen";
        dynamicStyle = "styles.right styles.rightGreen";
    } else if (carEgcPrice > kbbAskingPriceRangeMax) {
        position = "right";
        dynamicStyle = "styles.right";
    } else if (carEgcPrice < kbbAskingPriceRangeMin) {
        position = "left";
        dynamicStyle = "styles.left";
    }

    return (
        <div styleName="styles.outerWrapper">
            <div styleName="styles.wrapper">
                <div styleName={`styles.greenBox ${centerGreen}`}>
                    <span>Typical Dealer Asking Price</span>
                    <span>{makePriceLabelRound(midKbbValue)}</span>
                </div>
                <div styleName={`styles.wihteBox ${dynamicStyle}`}>
                    <span>Advertised Price</span>
                    <span>{makePriceLabelRound(carEgcPrice)}</span>
                    <span>Excl. Gov. charges</span>
                </div>
                <Kbbimage position={position} />
            </div>
        </div>
    );
};

KbbWrapper.propTypes = {
    kbbAskingPriceRangeMin: PropTypes.number,
    kbbAskingPriceRangeMax: PropTypes.number,
    position: PropTypes.string,
    carEgcPrice: PropTypes.number
};

export default KbbWrapper;
